import 'v-calendar/style.css'
import "quasar/dist/quasar.sass"
import '@/styles/quasar.scss'

import lang from 'quasar/lang/fr.js'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'

import Cookies from 'quasar/src/plugins/Cookies.js';import Dialog from 'quasar/src/plugins/Dialog.js';import Notify from 'quasar/src/plugins/Notify.js';import Screen from 'quasar/src/plugins/Screen.js';import SessionStorage from 'quasar/src/plugins/SessionStorage.js';

// To be used on app.use(Quasar, { ... })
export default {
  plugins: {
    Cookies,
    Dialog,
    Notify,
    Screen,
    SessionStorage
  },
  lang: lang
}